<template>
	<b-row>
		<b-col cols="12">
			<div id="parentx">
				<b-card>
					<template slot="header">
						{{ $t('sidebar.warehouse-management.extra-cost') }}
					</template>
					<b-card-body>
						<b-tabs>
							<b-tab :title="$t('sidebar.warehouse-management.income')">

								<filter-items @filtered="incomeFiltered($event)"></filter-items>

								<div class="table-wrapper">


									<b-table
										style="white-space: nowrap"
										class="generalTableClass mb-2"
										:items="incomes.items"
										:fields="incomes.fields"
										hover="hover"
										striped="striped"
										bordered="bordered"
										:current-page="incomes.search.page"
										:per-page="0"
										responsive
										show-empty
									>
										<!-- EMPTY SLOT FOR TABLE -->
										<template slot="empty" slot-scope="scope">
											<h4>{{ $t('empty') }}</h4>
										</template>
										<!-- EMPTY SLOT FOR TABLE -->

										<div slot="id" slot-scope="row">
											<strong>{{
													paginate(row.index, incomes.search.page,
														incomes.search.limit)
												}}</strong>
										</div>

										<div slot="regNumber" slot-scope="row">
											<span>{{ row.item.regNumber }}</span>
										</div>
										<div slot="reason" slot-scope="row">
											<div class="no-wrap">
												{{ row.item.reason }}
											</div>
										</div>
										<div slot="extraCosts" slot-scope="row">
											<div v-if="row.item.extraCosts>=0" class="no-wrap">
												{{
													row.item.extraCosts |currency({
														symbol: depCurrencyCode, fractionCount:
															2, symbolPosition: 'back'
													})
												}}

											</div>
											<div v-else class="no-wrap" style="display: flex;justify-content: center;">
												<span>---</span>
											</div>
										</div>
										<div slot="comment" slot-scope="row">
											<div class="no-wrap">
												{{ row.item.comment }}
											</div>
										</div>
										<div slot="regDate" slot-scope="row">
											<span>{{ formatDate(row.item.regDate) }}</span>
										</div>
										<template slot="actions" slot-scope="row">
											<div>
												<b-link v-if="row.item.extraCosts ==null"
														@click="addToItem(row.item,  'incomes')">
													<i class="fa fa-plus-circle"></i>
												</b-link>

												<b-link @click="toggleRow(row)">
													<i class="fa fa-chevron-down"></i>
												</b-link>

											</div>

										</template>
										<template slot="row-details" slot-scope="row">
											<div class="row">

												<div class="generalTableClass col-10"
													 v-if="row.item['costs'] && row.item['costs'].length > 0">
													<table class="table table-bordered">
														<tr>
															<th>№</th>
															<th style=" display: flex;justify-content: center;">{{$t('contragent.category-name')}}</th>
															<th style="text-align: center">Цена</th>
															<th style="text-align: center">Цена ({{ depCurrencyCode }})</th>
															<th>{{ $t('incomes.create.comment') }}</th>
														</tr>
														<tr v-for="(cost,index) in row.item['costs']" :key="cost.id">
															<td>{{ index + 1 }}</td>
															<td>{{ cost.categoryName }}</td>
															<td>{{ cost.currencyCost | currency({symbol: cost.currencyName, fractionCount: 2, symbolPosition: 'back'}) }}</td>
															<td>{{
																	cost.cost | currency({
																		symbol:
																		userDepCurrencyName,
																		fractionCount: 2,
																		symbolPosition:
																			'back'
																	})
																}}
															</td>
															<td>{{ cost.comment }}</td>

														</tr>
													</table>
												</div>
												<div class="col-2">
													<b-button
														v-if="row.item['costs'] && row.item['costs'].length > 0"
														:to="'/warehouse-management/extra-cost/' + row.item.id"
														class="mb-2" variant="primary" size="sm">{{
															$t('pricing.print')
														}}
													</b-button>
												</div>
											</div>
										</template>
									</b-table>
									<div v-if="incomes.loader" class="spinner-wrapper">
										<b-spinner variant="primary"></b-spinner>
									</div>

									<nav>
										<b-pagination :total-rows="incomes.total"
													  :per-page="incomes.search.limit"
													  v-model="incomes.search.page"
													  :prev-text="$t('pagination.prev')"
													  :next-text="$t('pagination.next')" hide-goto-end-buttons/>
									</nav>

								</div>
							</b-tab>
							<!-- <b-tab :title="$t('sidebar.warehouse-management.transfers')">

								<filter-items section="CHIQIM" @filtered="transferFiltered"></filter-items>

								<div class="table-wrapper">
									<b-table
										class="generalTableClass mb-2"
										:items="transfer.items"
										:fields="transfer.fields"
										hover="hover"
										striped="striped"
										bordered="bordered"
										:current-page="transfer.search.page"
										:per-page="0"
										responsive
										show-empty
									>
										<template slot="empty" slot-scope="scope">
											<h4>{{$t('empty')}}</h4>
										</template>

										<div slot="id" slot-scope="row">
											<strong>{{paginate(row.index, incomes.search.page,
												incomes.search.limit)}}</strong>
										</div>

										<div slot="regNumber" slot-scope="row">
											<span>{{row.item.regNumber}}</span>
										</div>
										<div slot="extraCosts" slot-scope="row">
											<div v-if="row.item.extraCosts" class="no-wrap">
												{{row.item.extraCosts | currency({symbol: depCurrencyCode,
												fractionCount: 2, symbolPosition: 'back'}) }}

											</div>
											<div v-else class="no-wrap" style="display: flex;justify-content: center;">
												<span>---</span>
											</div>
										</div>
										<div slot="reason" slot-scope="row">
											<div class="no-wrap">
												{{row.item.reason}}
											</div>
										</div>
										<div slot="comment" slot-scope="row">
											<div class="no-wrap">
												{{row.item.comment}}
											</div>
										</div>
										<div slot="regDate" slot-scope="row">
											<span>{{ formatDate(row.item.regDate) }}</span>
										</div>
										<template slot="actions" slot-scope="row">
											<div>
												<b-link @click="addToItem(row.item,  'transfer')">
													<i class="fa fa-plus-circle"></i>
												</b-link>
												<b-link @click="toggleRow(row)">
													<i class="fa fa-chevron-down"></i>
												</b-link>

											</div>

										</template>
										<template slot="row-details" slot-scope="row">


											<div class="row">
												<div class="generalTableClass col-11">
													<table class="table table-bordered">
														<tr>
															<th>№</th>
															<th style="text-align: center">{{
																$t('contragent.category-name') }}
															</th>
															<th style="text-align: center">{{ $t('pos.sum') }}</th>
															<th style=" display: flex; justify-content: center;">{{
																$t('incomes.create.comment') }}
															</th>

														</tr>
														<tr v-for="cost,index in row.item['costs']"
															:key="cost.id">
															<td>{{ index + 1 }}</td>
															<td style=" display: flex; justify-content: center;">{{
																cost.categoryName }}
															</td>
															<td>{{cost.cost| currency({
																symbol:
																userDepCurrencyName, fractionCount: 2, symbolPosition:
																'back'
																})}}
															</td>
															<td style=" display: flex;justify-content: center;">{{
																cost.comment }}
															</td>
														</tr>
													</table>
												</div>
												<div class="col-1">
													<b-button :to="'/warehouse-management/extra-cost/' + row.item.id"
															  class="mb-2" variant="primary" size="sm">{{ $t('Print')}}
													</b-button>
												</div>
											</div>
										</template>
									</b-table>
									<div v-if="incomes.loader" class="spinner-wrapper">
										<b-spinner variant="primary"></b-spinner>
									</div>

									<nav>
										<b-pagination :total-rows="transfer.total" :per-page="transfer.search.limit"
													  v-model="transfer.search.page" :prev-text="$t('pagination.prev')"
													  :next-text="$t('pagination.next')" hide-goto-end-buttons/>
									</nav>
								</div>
							</b-tab> -->
						</b-tabs>
					</b-card-body>
				</b-card>
			</div>
		</b-col>
		<vs-sidebar v-model="sidebar" :click-not-close="true" position-right
					parent="body" default-index="1" color="primary" class="create-modal" spacer>
			<b-container v-if="sidebar">
				<cost-form
					:document="document"
					@close="closeSidebar"
					@saved="saved"
				></cost-form>
			</b-container>
		</vs-sidebar>
	</b-row>
</template>

<script>
import {mapState} from 'vuex'
import {Incomes} from "./mixins/Incomes";
import {Transfers} from "./mixins/Transfer";
import moment from 'moment'
import CostForm from "./blocks/CostForm";
import ExtraCost from "../../../services/extraCost.service";
import FilterItems from "../wh-documents/blocks/filterItems";

export default {
	name: 'List',

	components: {FilterItems, CostForm},

	mixins: [Incomes, Transfers],

	data() {
		return {
			depCurrencyCode: '',
			document: null,
			sidebar: false,
			section: null,
			show: false
		}
	},
	mounted() {
		this.depCurrencyCode = localStorage.getItem("depCurrencyName");

	},
	computed: {
		...mapState(['userDepCurrencyName']),
	},
	methods: {

		/**
		 * Returns Item index
		 * @param index
		 * @param page_size
		 * @param page_number
		 * @returns {number}
		 */
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},

		/**
		 * Returns Formatted date
		 * @param date
		 * @returns {string}
		 */
		formatDate(date) {
			const split = date.split(' ');
			date = split[0];
			const revers = date.split('-');
			date = revers[2] + '-' + revers[1] + '-' + revers[0] + 'T00:00:00';
			return moment(String(date)).format('DD-MM-YYYY')
		},

		/**
		 *
		 * @param item
		 */

		addToItem(item, section) {
			setTimeout(() => {
				this.sidebar = true;
				this.document = item;
				this.section = section;
			}, 200)
		},

		/**
		 *
		 */
		closeSidebar() {
			setTimeout(() => {
				this.loadIncomes();
				this.loadTransfers();
			}, 200);
			this.sidebar = false;
		},

		/**
		 *
		 * @param $event
		 */
		saved($event) {
			this.closeSidebar()
		},

		loadByDocument(id) {
			return ExtraCost.loadByDocument(id)
		},

		toggleRow(row) {
			if (!row.item.loaded) {
				ExtraCost.loadByDocument(row.item.id).then(response => {
					row.item['costs'] = response;
					if (response.length > 0) {
						row.item['loaded'] = true
					}
				})
			}
			setTimeout(() => {
				row.toggleDetails();
			}, 200);

		}
	},
	watch: {
		'incomes.search.page': {
			handler(newValue, oldValue) {
				this.loadIncomes();
			}
		},
		'transfer.search.page': {
			handler() {
				this.loadTransfers();
			}
		}
	}
}
</script>

<style scoped>
.no-wrap {
	white-space: nowrap;
}

.w-300 {
	width: 50%;
	margin-left: 60px;
	margin-top: 20px;
	text-align: right;
}
</style>
